import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  enh_action: 'add',
  event_name: 'add_to_bag',
  event_category: 'ecommerce',
  event_action: 'add to bag',
  event_label: null, // '<product name> - <product ID>'
  product_id: null, // '<product id>'
  product_shade: null, // '<product shade>'
  product_size: null, // '<product size>'
  product_sku: null // '<sku id>'
};

function trackAddToCart(_: string, eventData: IDataLayer = {}) {
  if (eventData.is_pincer_cart) {
    eventData = trackAddToCartPincer(_, eventData);
  } else if (eventData.is_bf_cart) {
    eventData = trackAddToCartBF(_, eventData);
  } else {
    eventData.event_label = tealium.dataLayer.formatProductEventLabel(eventData);
  }

  tealium.evtLink({ ...defaultData, ...eventData });
}

function trackAddToCartPincer(_: string, eventData: IDataLayer = {}) {
  // TODO: investigate why this is being pulled from the data layer before the event is fired
  // why isn't this being passed in the actual event, then added to the datalayer?
  const data = tealium.dataLayer?.data || {};
  const sku = eventData.product_sku || [];

  if (eventData.product_sku?.length) {
    const skuIndex = data.cart_product_sku?.indexOf(sku[0]) ?? -1;

    if (skuIndex >= 0) {
      eventData = updateEventData(eventData, data, skuIndex, 'cart_product_');
    }
  }

  return eventData;
}

function trackAddToCartBF(_: string, eventData: IDataLayer = {}) {
  const productCodes = eventData.product_product_code || [];
  const data = tealium?.dataLayer?.data || {};

  if (productCodes.length) {
    let skuIndex = -1;
    if (data.page_type === 'product') {
      skuIndex = data.product_product_code?.indexOf(productCodes[0]) ?? -1;
    } else {
      skuIndex = data.product_impression_product_code?.indexOf(productCodes[0]) ?? -1;
    }

    if (skuIndex >= 0) {
      if (data.page_type === 'product') {
        eventData = updateEventData(eventData, data, skuIndex);
      } else {
        eventData = updateEventData(eventData, data, skuIndex, 'product_impression_');
      }
    }
  }

  return eventData;
}

function updateEventData(
  eventData: IDataLayer,
  data: IDataLayer,
  skuIndex: number,
  prefix = 'product_'
) {
  eventData.event_label = tealium.dataLayer.formatProductEventLabel({
    product_name: [data[`${prefix}name`]?.[skuIndex] || ''],
    product_id: [data[`${prefix}id`]?.[skuIndex] || '']
  });
  eventData.product_id = [data[`${prefix}id`]?.[skuIndex] || ''];
  eventData.product_is_replenishment_item = [
    data[`${prefix}is_replenishment_item`]?.[skuIndex] || false
  ];
  eventData.product_price = [data[`${prefix}price`]?.[skuIndex] || ''];
  eventData.product_code = [data[`${prefix}product_code`]?.[skuIndex] || ''];
  eventData.product_replenishment_frequency = [
    data[`${prefix}replenishment_frequency`]?.[skuIndex] || ''
  ];
  eventData.product_shade = [data[`${prefix}shade`]?.[skuIndex] || ''];
  eventData.product_size = [data[`${prefix}size`]?.[skuIndex] || ''];
  eventData.product_sku = [data[`${prefix}sku`]?.[skuIndex] || ''];

  return eventData;
}

registerAnalyticsEventHandler('addToCart', trackAddToCart);
